<template>
  <div>
    <van-nav-bar
      :title="$store.state.titleText"
      left-text="返回"
      left-arrow
      @click-left="back"
    >
      <template #right>
        <PopupMenu :popupText="$store.state.popupText"
        :menuItems="$store.state.popupMenuText" />
      </template>
    </van-nav-bar>
  </div>
</template>

<script>
import PopupMenu from "@/components/PopupMenu";
// import EventBus from '@/util/eventBus'; // 导入事件总线
export default {
  components: {
    PopupMenu,
  },
  name: "MyHeader",
  props: {
    rightText: {
      type: String,
      default: "...", // 默认文本
    },
  },
  data() {
    return {
      isOpen: false, // 控制弹出菜单的显示状态
      menuItems: ["功能1", "功能2", "功能3", "功能4"], // 菜单选项
    };
  },
  methods: {
    back() {
      // 实现返回逻辑
      this.$router.go(-1); // 示例返回上一页
    },
  },
};
</script>

<style>
.header {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
}

.more {
  font-size: 20px;
  margin: 0 5px;
}
</style>
